import e from"react";var a=function(a){var t=a.src,r=a.altText;return e.createElement(e.Fragment,null,t&&e.createElement("div",{className:"c-image-container"},e.createElement("img",{alt:r,className:"c-image",src:t})))};export{a as Image};
//# sourceMappingURL=Image.js.map
